module.exports = __webpack_public_path__ + "StopMTLca_Logo2.png?31df8c09e03bd51d70e14e2c43bc945d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/StopMTLca_Logo2.png
// module id = 312
// module chunks = 9